export default "__VITE_ASSET__CPPMitmh__"